<template>
	<div>
		<div>
			<el-dialog title="异常监测设置" :visible.sync="dialogFormVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')" center>
			  <el-form :model="form" ref="form" :label-width="$store.state.width>$store.state.minwidth?'110px':''">
				<el-form-item label="选择设备" prop="equipmentvalue" :rules="{ required: true, message: '设备不能为空', trigger: 'blur' }">
					 <el-select v-model="form.equipmentvalue" placeholder="请选择" style="width: 100%;" @change="changes()">
						<el-option
						  v-for="item in form.equipments"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value" 
						  :size="medium">
						</el-option>
					  </el-select>
				</el-form-item>
				<el-form-item label="表达式" prop="expressionvalue" :rules="{ required: true, message: '表达式不能为空', trigger: 'blur' }">
					<el-input
					  type="textarea"
					  :autosize="{ minRows: 2, maxRows: 6}"
					  placeholder="设置以下下拉菜单自动合成表达式"
					  v-model="form.expressionvalue"
					  :disabled="true">
					</el-input>
				</el-form-item>
				<div v-for="(item, key) in form.ruleForm" :key="key">
					<el-row>
						<el-col :span="9">
							<el-form-item label=" " :prop="'ruleForm.' + key + '.sensorsvalue'" :rules="{ required: true, message: '请选择', trigger: 'blur' }">
								<el-select v-model="form.ruleForm[key].sensorsvalue" placeholder="请选择传感器" @change="forchanges()">
									<el-option
									  v-for="item in form.sensors"
									  :key="item.value"
									  :label="item.label"
									  :value="item.value" 
									  :size="medium">
									</el-option>
								 </el-select>
							</el-form-item>
						</el-col>
						<el-col :span="4">
							<el-form-item :prop="'ruleForm.' + key + '.judgevalue'" :rules="{ required: true, message: '请选择', trigger: 'blur' }">
								 <el-select v-model="form.ruleForm[key].judgevalue" placeholder="请选择" @change="forchanges()">
								   <el-option label="大于" value=">"></el-option>
								   <el-option label="小于" value="<"></el-option>
								 </el-select>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item :prop="'ruleForm.' + key + '.sizevalue'" :rules="[{ required: true, message: '不能为空', trigger: 'blur' },{ type: 'number', message: '只能填数字'}]">
								 <el-input v-model.number="form.ruleForm[key].sizevalue" placeholder="请输入值" @input="forchanges()"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="4">
							<el-form-item v-if="key!=(form.ruleForm.length-1)" :prop="'ruleForm.' + key + '.relationvalue'" :rules="{ required: true, message: '请选择', trigger: 'blur' }">
								 <el-select v-model="form.ruleForm[key].relationvalue" placeholder="请选择" @change="forchanges()">
								   <el-option label="并且" value="and"></el-option>
								   <el-option label="或者" value="or"></el-option>
								 </el-select>
							</el-form-item>
							<el-form-item></el-form-item>
						</el-col>
						<el-col :span="2">
							<el-form-item style="float: right;">
								 <el-button type="primary" icon="el-icon-minus" @click="remove(key)" circle></el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<el-form-item v-if="form.ruleForm.length < 5" align="center">
					<el-button type="primary" icon="el-icon-plus" @click="add()" circle></el-button>
				</el-form-item>
			  </el-form>
			  <div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addExpression('form')">确 定</el-button>
				<el-button @click="dialogFormVisible = false">取 消</el-button>
			  </div>
			</el-dialog>
		</div>
		<div>
			<el-row>
				<el-col :span="24">
					<div class="bread">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>异常监测设置</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<el-row class="top">
				<el-col :span="24">
					<el-button type="primary" :size="$store.state.width<$store.state.minwidth?'mini':''" icon="el-icon-circle-plus-outline" @click="openExpression()">新增策略</el-button>
					<el-button type="success" :size="$store.state.width<$store.state.minwidth?'mini':''" icon="el-icon-remove-outline" @click="deleteExpression()">删除策略</el-button>
				</el-col>
			</el-row>
			<el-row class="top">
				<el-col :span="24">
					<div>
						<el-table
						  :size="$store.state.width<$store.state.minwidth?'mini':''"
						  ref="multipleTable"
						  :data="tableData3"
						  tooltip-effect="dark"
						  @selection-change="handleSelectionChange">
							<el-table-column type="selection"></el-table-column>
							<el-table-column
							  label="启用状态"
							  header-align="center"
							  align="center"
							  width="130">
								<template slot-scope="scope">
									<div v-if="scope.row.state === '未开启'">
										<el-tooltip content="未开启,点击开启" placement="top" effect="light">
											<el-button :size="$store.state.width<$store.state.minwidth?'mini':''" id="" type="info" icon="el-icon-warning" @click="changeState(scope.$index)">{{ scope.row.state }}</el-button>
										</el-tooltip>
									</div>
									<div v-else>
								  	<el-tooltip content="启用中,点击关闭" placement="top" effect="light">
										<el-button :size="$store.state.width<$store.state.minwidth?'mini':''" id="" type="success" icon="el-icon-success" @click="changeState(scope.$index)">{{ scope.row.state }}</el-button>
								  	</el-tooltip>
								  </div>
							  </template>
							</el-table-column>
							<el-table-column
							  prop="expression"
							  label="条件表达式"
							  header-align="center"
							  align="center"
							  >
							</el-table-column>
							<el-table-column
							  prop="terminal"
							  label="关联设备终端"
							  header-align="center"
							  align="center"
							  show-overflow-tooltip
							  width="200">
							</el-table-column>
							<el-table-column
							  prop="creator"
							  label="创建人"
							  header-align="center"
							  align="center"
							  width="130"
							  show-overflow-tooltip>
								<template slot-scope="scope">
									<el-tag type="success" disable-transitions>{{scope.row.creator}}</el-tag>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	export default {
    data() {
      return {
        tableData3: [{
          state: '未开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
		  creator: '张三',
		  id: 1
        }, {
          state: '未开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
		  creator: '李四',
		  id: 2
        }, {
          state: '启用中',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
		  creator: '王五',
		  id: 3
        }, {
          state: '启用中',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
		  creator: '张四',
		  id: 4
        }, {
          state: '未开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
		  creator: '小明',
		  id: 5
        }, {
          state: '未开启',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
		  creator: '李三',
		  id: 6
        }, {
          state: '启用中',
          expression: '{电压}<200 and {电压}>600',
          terminal: 'qq(TCP通信协议)',
		  creator: '王二',
		  id: 7
        }],
		multipleSelection: [],
		dialogFormVisible: false,
        form: {
          equipmentvalue: '',
          expressionvalue: '',
          equipments: [{
						value: '设备1',
						label: '设备1'
					  }, {
						value: '设备2',
						label: '设备2'
					  }, {
						value: '设备3',
						label: '设备3'
					  }, {
						value: '设备4',
						label: '设备4'
					  }, {
						value: '设备5',
						label: '设备5'
					  }],
		  sensors: [{
						value: '电压',
						label: '传感器1'
					  }, {
						value: '温度',
						label: '传感器2'
					  }, {
						value: '压强',
						label: '传感器3'
					  }, {
						value: '浓度',
						label: '传感器4'
					  }, {
						value: '速度',
						label: '传感器5'
					  }],
		  ruleForm: [{
				  sensorsvalue: '',
				  judgevalue: '',
				  sizevalue: '',
				  relationvalue: ''
			  },{
			  	  sensorsvalue: '',
			  	  judgevalue: '',
			  	  sizevalue: '',
			  	  relationvalue: ''
			   }]
        },
        formLabelWidth: '120px'
      }
    },

    methods: {
		changeState(index)
		{
			if(this.tableData3[index]["state"] === "未开启")
			{
				this.tableData3[index]["state"] = "启用中";
				this.$message({message: '成功启用！',type: 'success'});
			}
			else
			{
				this.tableData3[index]["state"] = "未开启";
				this.$message({message: '成功关闭！',type: 'success'});
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		deleteExpression()
		{
			for(var i=0;i<this.multipleSelection.length;i++)
			{
				var index = this.tableData3.indexOf(this.multipleSelection[i]);
				this.tableData3.splice(index,1);
				console.log("删除了："+this.multipleSelection[i]["id"]);
			}
			if(this.multipleSelection.length != 0)
			{
				this.$message({message: '成功删除'+this.multipleSelection.length+'条！',type: 'success'});
			}
		},
		openExpression()
		{
			this.dialogFormVisible = true;
			this.$refs['form'].resetFields();
// 			this.form.equipmentvalue = '';
// 			this.form.expressionvalue = '';
			this.form.ruleForm = [{
				  sensorsvalue: '',
				  judgevalue: '',
				  sizevalue: '',
				  relationvalue: ''
			  },{
			  	  sensorsvalue: '',
			  	  judgevalue: '',
			  	  sizevalue: '',
			  	  relationvalue: ''
			   }];
		},
		addExpression(formName)
		{
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				this.dialogFormVisible = false;
				this.tableData3.push({
					  state: '未开启',
					  expression: this.form.expressionvalue,
					  terminal: this.form.equipmentvalue,
					  creator: '王二',
					  id: 7
					});
				this.$message({message: '添加成功！',type: 'success'});
			  } else {
			    this.$message.error('添加失败！');
			    return false;
			  }
			});
		},
		changes()
		{
			console.log("选中了"+this.form.equipmentvalue)
		},
		forchanges()
		{
			var str = "";
			for(var i=0;i<this.form.ruleForm.length;i++)
			{
				if(this.form.ruleForm[i]["sensorsvalue"] != "")
				{
					str += ("{" + this.form.ruleForm[i]["sensorsvalue"] + "}");
				}
				if(this.form.ruleForm[i]["judgevalue"] != "")
				{
					str += (this.form.ruleForm[i]["judgevalue"]+ "");
				}
				if(this.form.ruleForm[i]["sizevalue"] != "")
				{
					str += (this.form.ruleForm[i]["sizevalue"]+ " ");
				}
				if(this.form.ruleForm[i]["relationvalue"] != "")
				{
					str += (this.form.ruleForm[i]["relationvalue"]+ " ");
				}
			}
			this.form.expressionvalue = str;
		},
		add()
		{
			if(this.form.ruleForm.length<5)
			{
				this.form.ruleForm.push({
						  sensorsvalue: '',
						  judgevalue: '',
						  sizevalue: '',
						  relationvalue: ''
				})
			}
		},
		remove(key)
		{
			this.form.ruleForm.splice(key,1);
			this.forchanges();
		}
    }
  }
</script>

<style scoped>
	.top{
		margin-top: 10px;
	}
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			padding-left: 5px;
		}
	}
</style>
